<template>
  <div class="companywrap">
    <!-- *****2022年2-7日 因数据是2021年的。主办要求不显示，注释掉现实数据部分，带数据更新请解开注释 by chenhaowei start **** -->

    <div class="choosewrap">
      <div class="choosebtn" @click="chooseShow">{{$t('exhibitor.filter')}}</div>
      <el-input
        prefix-icon="el-icon-search"
        :placeholder="placeholder"
        v-model="keywords"
        clearable>
      </el-input>
      <div class="search" @click="search">{{$t('exhibitor.search')}}</div>
      <div class="moblie-filter" @click="chooseShow"><img src="../../../assets/screen.png" alt="" srcset="">{{$t('exhibitor.filter')}}</div>
    </div> 
    <div class="companyWrap" v-if=" companyList.length > 0">
      <div class="companylist" v-for="(item, index) in companyList" :key="item.id" @click="toDetail(item.id)">

        <div v-if="item.logo.length > 0" class="logo_out">
          <img  class="logo" :src="$imgUrl + item.logo" alt="">
        </div>
        <div  v-else class="logo_out">
          <img class="logo" src="../../../assets/logo.jpg" alt="">
        </div>
        <div class="middle">
          <p v-if="langSet == 'zh'" class="title">{{item.companyName}}</p>
          <p v-if="langSet == 'en'" class="title">{{item.enCompanyName?item.enCompanyName:item.companyName}}</p>
          <p>
            <span v-if="langSet == 'zh'">{{item.country}}</span>
            <span v-if="langSet == 'en'" >{{item.en_country?item.en_country:item.en_country}}</span>
            <span v-if="item.province || item.en_country">-</span>
            <span v-if="langSet == 'zh'">{{item.province}}</span>
            <span v-if="langSet == 'en'" >{{item.en_province?item.en_province:item.province}}</span>
          </p>
          <p v-if="langSet == 'zh'" class="sub">
            <span>{{item.exhibitionArea}}</span>
            <span v-if="item.hallNo || item.boothNo">/</span>
            <span>{{item.hallNo}}</span>
            <span>{{item.boothNo}}</span>
          </p>
          <p v-if="langSet == 'en'" class="sub">
            <span>{{item.en_exhibitionArea?item.en_exhibitionArea:item.exhibitionArea}}</span>
            <span v-if="item.hallNo || item.boothNo">/</span>
            <span>{{item.en_hallNo?item.en_hallNo:item.hallNo}}</span>
            <span>{{item.boothNo}}</span>
          </p>
        </div>
        <div class="right">
            <img class="collect-icon" v-if="item.isCollect == 0" @click.stop="collectBtn(item.id, 1, index)" src="../../../assets/collect.png" alt="">
            <img class="collect-icon" v-if="item.isCollect == 1" @click.stop="collectBtn(item.id, 0, index)" src="../../../assets/collect_en.png" alt="">
            <div class="carrow">
              <p class="el-icon-arrow-right carrow-right"></p>
              <p class="eye-icon"><img src="../../../assets/eye.png" alt="">{{item.clicknum}}</p>
            </div>
        </div>
      </div>
    </div>
    <el-pagination
      hide-on-single-page
      background
      layout="total,prev,pager,next"
      :page-size="pagesize"
      @current-change="changePage"
      :total="total">
    </el-pagination>
    <div class="maskwrap" v-if="isShow">
      <div class="maskmain">
        <div class="el-icon-close" @click="closeChoose" style="font-size: 40px;cursor: pointer;"></div>
        <div class="masklist">
          <p class="masktitle">{{$t('exhibitor.productGroups')}}</p>
          <div :class="[productid == item.linkageid ? 'select' : '', 'masklabel', 'productlabel']" v-for="(item, index) in productType" :key="index" @click="choosePList(item.linkageid)">
            <span>
                <b v-if="langSet == 'zh' || item.description.length == 0">{{item.name}}</b>
                <b v-if="langSet == 'en' && item.description.length > 0">{{item.description}}</b>
                <i v-if="item.child.length > 0 && productid == item.linkageid" class="el-icon-arrow-down"></i>
                <i v-if="item.child.length > 0 && productid != item.linkageid" class="el-icon-plus"></i>
            </span>
            <div class="submasknav" v-if="item.child.length > 0">
              <i class="el-icon-caret-top"></i>
              <p v-for="(_item,_index) in item.child" :key="_index">
                <span v-if="langSet == 'zh' || _item.description.length == 0" :class="[subMenuid == _item.linkageid ? 'active' : '']" @click.stop="levelClick(_item.linkageid)">{{_item.name}}</span>
                <span v-if="langSet == 'en' && _item.description.length > 0" :class="[subMenuid == _item.linkageid ? 'active' : '']" @click.stop="levelClick(_item.linkageid)">{{_item.description}}</span>
              </p>
            </div>
          </div>
        </div>
       
        <div class="masklist">
          <p class="masktitle">{{$t('exhibitor.countryRegion')}}</p>
          <div class="masklabel">
            <p v-for="(item, index) in countryList" :key="index">
              <span v-if="langSet == 'zh' || item.en_country.length == 0" :class="[countrytext == item.country ? 'active' : '']" @click="chooseCList(item.country)">{{item.country}}</span>
              <span v-if="langSet == 'en' && item.en_country.length > 0" :class="[countrytext == item.country ? 'active' : '']" @click="chooseCList(item.country)">{{item.en_country}}</span>
            </p>
          </div>
        </div>
        <div class="maskbtn">
          <span class="reset" @click="reset">{{$t('exhibitor.reset')}}</span>
          <span @click="searchBtn">{{$t('exhibitor.searchresult')}}</span>
        </div>
      </div>
    </div> 
   <div class="nodata" style="padding:210px 0;" v-if="companyList.length = 0">
      <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
      <img v-else src="../../../assets/nodata01.png" alt="">
    </div>
     <!-- 2022年2-7日 end -->
     <!-- <div class="nodata" style="padding:210px 0;">
       <div v-if="langSet == 'zh'" style="font-size:20px;">敬请期待</div>
       <div v-else  style="font-size:20px;">Coming Soon</div>
     </div> -->
  </div>
</template>

<script>
import { getCompanyList, getAll, getCollect,getCountry,getSession } from "@/api/api";
export default {
  data() {
    return {
      keywords: '',
      business_1: '',
      business_2: '',
      productClass_1: '',
      productClass_2: '',
      country: '',
      showareaid: '',
      pagesize: 11,
      page: '1',
      companyList:[],
      input: '',
      isShow: false,
      total: 0,
      productType: [],
      sessionList: [],
      countryList:[],
      countrytext: '',
      sessionid: -1,
      productid: -1,
      subMenuid: -1,
      placeholder: '',
      langSet: ''
    };
  },
  created() { 
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    this.showareaid = this.$route.query.id;
    this.memberid = localStorage.getItem('memberid');
    this.placeholder = this.$t('exhibitor.placeholder');
    if(this.showareaid != ''){
      let data =this.$qs.stringify({
        keywords: this.keywords,
        showareaid: this.showareaid,
        memberid: this.memberid,
        pagesize: this.pagesize,
        page: this.page
      });
      this.getList(data);
    }else{
      let data = this.$qs.stringify({
        keywords: this.keywords,
        business_1: this.business_1,
        business_2: this.business_2,
        productClass_1: this.productClass_1,
        productClass_2: this.productClass_2,
        country: this.country,
        showareaid: this.showareaid,
        pagesize: this.pagesize,
        page: this.page
      });
      this.getList(data);
    }
  },
  methods: {
    getList(data){
      var that = this;
      getCompanyList(data).then(res=>{
        console.log('展商列表', res.data)
        if(res.data.errno == 0){
          that.companyList = res.data.rst;
          this.total = Number(res.data.errmsg);
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    search(){
      //console.log(this.keywords)
      if(this.keywords == 0){
        this.$message('请输入公司名称或展位号');
        return false;
      }
      if(this.showareaid != ''){
        let data =this.$qs.stringify({
          keywords: this.keywords,
          showareaid: this.showareaid,
          memberid: this.memberid,
          pagesize: this.pagesize,
          page: this.page
        });
        this.getList(data);
      }else{
        let data = this.$qs.stringify({
          keywords: this.keywords,
          business_1: this.business_1,
          business_2: this.business_2,
          productClass_1: this.productClass_1,
          productClass_2: this.productClass_2,
          country: this.country,
          showareaid: this.showareaid,
          pagesize: this.pagesize,
          page: this.page
        });
      }
    },
    collectBtn(id,state,index){
      //console.log(id)
      let data = this.$qs.stringify({
        memberid: this.memberid,
        type: 2,
        dataid: id,
        status: state
      })
      let message = this.companyList;
      getCollect(data).then(res=>{
        //console.log(res)
        if(res.data.errno == 0){
          for (let i in message) {
            if (i == index) {
              if (message[i].isCollect == 1) {
                message[i].isCollect = 0
              } else {
                message[i].isCollect = 1
              }
            }
          }
          this.companyList = message;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    changePage(val){
      console.log('aa')
      this.page = val;
      if(this.showareaid != ''){
        let data = this.$qs.stringify({
          keywords: this.keywords,
          showareaid: this.showareaid,
          pagesize: this.pagesize,
          page: this.page,
          total: 0
        })
        this.getList(data)
      }else{
        let data = this.$qs.stringify({
          keywords: this.keywords,
          business_1: this.business_1,
          business_2: this.business_2,
          productClass_1: this.productClass_1,
          productClass_2: this.productClass_2,
          country: this.country,
          showareaid: this.showareaid,
          pagesize: this.pagesize,
          page: this.page,
          total: 0
        })
        this.getList(data)
      }
    },
    chooseShow(){
      this.isShow = true;
      //筛选类型    
      this.getAllList(3360);
      this.getSessionList();
      this.getCountryList();
    },
    getAllList(keyid){
      let data = this.$qs.stringify({
        keyid
      })
      //console.log(data)
      getAll(data).then(res=>{
        //console.log(res.data.rst.data)
        if(res.data.errno == 0){
          this.productType = res.data.rst.data;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getSessionList(){
      getSession().then(res=>{
        //console.log(res.data.rst)
        if(res.data.errno == 0){
          this.sessionList = res.data.rst;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getCountryList(){
      getCountry().then(res=>{
        //console.log(res.data.rst)
        if(res.data.errno == 0){
          this.countryList = res.data.rst;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    chooseCList(text){
      if(this.countrytext != text){
        this.countrytext = text;
      }else{
        this.countrytext = '';
      }
    },
    chooseSList(id){
      if(this.sessionid != id){
        this.sessionid = id;
      }else{
        this.sessionid = -1;
      }
    },
    choosePList(id){
      if(this.productid != id){
        this.productid = id;
      }else{
        this.productid = -1;
      }
    },
    levelClick(id){
      if(this.subMenuid != id){
        this.subMenuid = id;
      }else{
        this.subMenuid = -1;
      }
    },
    closeChoose(){
      this.isShow = false;
    },
    toDetail(id){
      //console.log(id)
      this.$router.push({
        name:"exhibitorDetail",
        query:{id}
      });
    },
    reset(){
      this.productid = -1;
      this.subMenuid = -1;
      this.sessionid = -1;
      this.countrytext = '';
    },
    searchBtn(){
      // console.log(this.productid, this.subMenuid, this.sessionid, this.countrytext )
      this.isShow = false;
      let data = this.$qs.stringify({
        keywords: this.keywords,
        memberid: this.memberid,
        business_1: this.business_1,
        business_2: this.business_2,
        productClass_1: this.productid,
        productClass_2: this.subMenuid,
        country: this.countrytext,
        showareaid: this.showareaid,
        session_id: this.sessionid,
        pagesize: this.pagesize,
        page: this.page
      });
      this.getList(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.companyWrap{margin-top: 36px;}
.companylist{
  .logo_out{
    width:98px;height:98px;border-radius:2px;border:1px solid #ccc;display: flex;align-items: center;overflow: hidden;
  }
  border-radius:9px;border:2px solid #979797;padding: 11px 33px 11px 11px;box-sizing: border-box;display: flex;justify-content: space-between;margin-bottom: 20px;cursor: pointer;
  .logo{width: 100%;}
  .middle{
    flex: 1;padding-left: 27px;color:rgba(0,0,0,0.5);font-size: 20px;line-height: 20px;display: flex;flex-wrap: wrap;
    p{width: 100%;}
    .sub{align-self: flex-end;}
    .title{font-size:22px;color: #000;font-weight: 600;line-height: 32px;}
  }
  .right{
    display: flex;padding-top: 35px;box-sizing: border-box;
    // right: -10px;
    .collect-icon{width: 24px;height: 22px;margin-right: 27px;}
    .carrow-right{font-size: 36px;font-weight: bold;line-height: 30px;margin-bottom: 20px;}
    .eye-icon{
      color: #7F7F7F;font-size: 14px;
      img{width:12px;height:8px;margin-right: 6px;}
      // margin-left: -30px;
    }
  }
}

.maskwrap{position: fixed;width: 100%;height: 100%;top: 0;left: 0;background:rgba(0,0,0,.5);}
.maskmain{width:800px;background: #fff;padding:27px 50px 77px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);box-sizing: border-box;height: 70%;overflow-y: scroll;}
.maskmain .masktitle{font-size:24px;font-weight: 600;line-height: 33px;}
.masklist{margin-bottom: 50px;padding: 0 20px;}
.masklist .masklabel span{background:rgba(238,238,238,1);border-radius:4px;display: inline-block;padding: 5px 10px;font-size:18px;color: #000;cursor: pointer;margin: 10px 10px 0 0;}
.masklist .masklabel span.active{background: #9B8B1C;color: #fff;}
.maskbtn{display: flex;justify-content: center;}
.maskbtn span{display: inline-block;cursor: pointer;width:153px;height:40px;text-align: center;line-height: 40px;font-size: 18px;color: #fff;background:#CAC28A;border-radius:3px;}
.masklist .masklabel span > i{font-size: 14px;position: relative;top: -2px;}
.maskbtn span.reset{background:#CAC28A;color: #000;margin-right: 26px;}
.productlabel{display: inline-block;}
.productlabel.select > span{background:#9B8B1C ;color: #fff;}
.productlabel.select .submasknav{display: flex;flex-wrap: wrap;}
.submasknav{display: none;background: #CAC28A;padding: 10px 10px 20px 10px;margin-top: 16px;position: relative;width: 700px;}
.submasknav i{position: absolute;top: -15px;color: #fff2f2;font-size: 22px;}
.masklist .masklabel .submasknav span{background: #fff;cursor: pointer;}
.masklist .masklabel .submasknav span.active{background: #9B8B1C ;color: #fff;}
.moblie-filter{display: none;}
@media only screen and (max-width: 767px){
  .companyWrap {
    margin-top: 0.36rem;
  }
  // 分页
  .companywrap .el-pagination{padding: 0.05rem;height: 0.5rem;}
  .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]),
  .companywrap .el-pager li{font-size: 12px;}
  .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.4rem;}
  .companywrap .el-pagination.is-background .el-pager li{width: 0.4rem;height: 0.4rem;line-height: 0.4rem;}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: 0;margin: 0 0.03rem;}
  .companywrap .el-pagination .btn-next .el-icon, .companywrap .el-pagination .btn-prev .el-icon{font-size: 12px;line-height: 0.4rem;}
  .el-pagination button, .el-pagination span:not([class*=suffix]){margin-right: 0;}
  // 分页
  .companylist{
    padding:10px 15px;
    background:#fff;
    border:0 none;
    box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
    border-radius:10px;
    .logo{width:100%;border:0 none;}
    .middle{
      padding-left: 0.2rem;
      p{
        font-size: 12px;
      }
      .title{font-size: 14px;line-height: 18px;}
    }
    .right{
      display: none;
    }
  }
  .maskmain{
    width: 80%;height: 60%;overflow-y: scroll;padding:0.2rem;border-radius: 10px;
    .el-icon-close{
      font-size: 30px !important;
      display: block;
      text-align: right;
    }
    .masktitle{font-size: 16px;}
    .masklist{
      margin-bottom: 0.5rem;
      .masklabel {
        span{
          font-size: 14px;
        }
      }
    }
    .maskbtn span{width: 2rem;}
  }
  .submasknav{width: 95%;}
  .choosewrap{
    .choosebtn,.search{display: none;}
    .el-input{width: 4.4rem;}
    .el-input__inner{
      width: 4.4rem;
      height: 0.6rem;
      font-size: 12px ;
    }
    .el-input__icon{font-size: 16px;line-height: 0.6rem;}
    .el-input__prefix{left: 0;}
    .el-input--prefix .el-input__inner{padding-left: 0.4rem;padding-right: 0.1rem;}
  } 
  .moblie-filter{
    display: block;
    flex: 1;
    font-size: 12px;
    color: #303030;
    text-align: right;
    // line-height: 0.9em;
    display: flex;
    align-items: center;
    padding-left: 10px;
    img{
      width: 0.28rem;
      margin-right: 0.1rem;
      position: relative;
      top: 0.05rem;
    }
  }
}
</style>
